import { t } from 'typy'

// Bitmask checking function
export function hasFlags (flags = [], value = 0) {
    if (!t(flags).isArray) throw new TypeError(`Invalid type for flags. Expecting an array instead received a ${typeof flags}.`)
    if (!t(value).isNumber) throw new TypeError(`Invalid type for value. Expecting a number instead received a ${typeof flags}.`)

    return flags.every(flag => flag & value)
}
